import React from 'react'
import {withForm, Errors, Form,TextInput} from 'startlibs/lib/form'
import {withToggles} from 'startlibs/lib/hocs'
import {Button} from 'startlibs/lib/components'
import {buildValidation} from '../lib/validation'
import {CardContent} from './SharingComponents'
import {simpleFetch} from '../lib'

@withForm()
@withToggles('loading')
export class DOBAuth extends React.PureComponent {

  preValidation = buildValidation({
    patientDOB: (v) => !new Date(v).getTime() && "Invalid date."
  })

  onSubmit = (e) => {
    e.preventDefault()
    if (!this.props.form.connector.validate()) { return }
    this.props.loading.open()
    const patientDOB = this.props.form.properties.patientDOB.split(/\//)
    const patientParam = patientDOB ? `dobCheck=${window.encodeURIComponent(patientDOB[2]+patientDOB[0]+patientDOB[1])}` : ''
    simpleFetch(`/api/share/download/${this.props.uuid}?${patientParam}`,{method:"HEAD"})
      .then((result) =>
        this.props.onSuccess(patientParam)
      ).catch((e) => {
        this.props.loading.close()
        if (e && e.status === 403) {
          this.props.form.connector.setErrors({'patientDOB':['Invalid date of birth. Check the date formatting and the patient records\' date of birth and try again']})
        } else {
          this.props.expired()
        }
    })
  }

  render() {
    const {form, loading, studyInfo} = this.props
    return <React.Fragment>
      <CardContent>
        <h2>Shared study details</h2>
        {studyInfo.patientName && <div className="patient-name">Patient: {studyInfo.patientName}</div>}
        <Form
          form={form}
          preValidation={this.preValidation}
          onSubmit={this.onSubmit}
        >
          <TextInput
            form={form}
            path="patientDOB"
            constraint="##/##/####"
            label="Insert patient’s date of birth to access the study:"
            placeholder="MM/DD/YYYY"
          />
          <Button isLoading={loading.isOpen} type="submit" highlight>Download study</Button>
          <Errors form={form} />
        </Form>
      </CardContent>
    </React.Fragment>
  }

}



// WEBPACK FOOTER //
// ./src/javascripts/shareModule/DOBAuth.jsx